import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  profileProgress: 0,
  profileCompletionRedux: 0,
  totalFields: 40,
  formStepName: {}
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    profileProgressValue: (state, action) => {
      const { type, value } = action.payload;
      state.formStepName[type] = value;
      // state.profileProgress = state.profileProgress + value;
      let sum = 0;
      for (let key in state.formStepName) {
        sum += state.formStepName[key];
      }
      if (sum > 100) {
        state.profileProgress = 100;
      } else {
        state.profileProgress = sum;
      }
    },
    resetProgressStates: (state, action) => {state.profileCompletionRedux = action.payload},
    setTotalFields: (state, action) => {
      state.totalFields = 36;
    },
    setProfile: (state, action) => {
      try {
        const { leanerApiData, profileImg } = action.payload;
        let data = leanerApiData;

        // Exclude fields from the calculation
        const excludedFields = new Set([
          'id',
          'prospectId',
          'description',
          'countryCode',
          'latitude',
          'longitude',
          'profileCompletion',
          'programName',
          'requiredPlacementAssistantStage',
          'source',
          'updatedAt',
          'createdAt'
        ]);

        // Count the total number of fields
        let totalFields = 40;
        let totalFieldsFinal = false;
        function countFilledKeys(obj, excludedKeys = []) {
          let count = 0;
          const keysToExclude = new Set(excludedKeys);

          function countKeys(obj) {
            for (const key in obj) {
              if (
                key === 'placementAssistanceRequired' &&
                obj['placementAssistanceRequired'] != undefined &&
                obj['placementAssistanceRequired'] === 'Yes'
              ) {
                totalFieldsFinal = true;
              }
              if (key === 'educationalQualifications') {
                continue;
              }
              if (!keysToExclude.has(key) && obj.hasOwnProperty(key)) {
                const value = obj[key];
                if (Array.isArray(value) && value?.length) {
                  count++;
                } else if (
                  value !== '' &&
                  value !== null &&
                  value !== undefined &&
                  typeof value !== 'object'
                ) {
                  count++;
                } else if (typeof value === 'object' && value !== null) {
                  countKeys(value); // Recursive call for nested objects
                }
              }
            }
          }

          countKeys(obj);
          return count;
        }
        let filledFields = countFilledKeys(data, excludedFields);
        const excludedEducationalKeys = (type) => {
          switch (type) {
            case 'PG':
              return ['id', 'type'];
            case 'UG':
              return ['id', 'type'];

            default:
              return [
                'id',
                'type',
                'level',
                'collegeName',
                'yearOfPassing',
                'specialization'
              ];
          }
        };

        // Education qualification data
        if (data['educationalQualifications']?.length) {
          data['educationalQualifications'].map((val) => {
            const excludedFields = excludedEducationalKeys(val.type);
            let res = [];
            res = Object.keys(val).filter(
              (key) => !excludedFields.includes(key) && val[key]?.length
            );
            filledFields += res?.length;
          });
        }

        if (totalFieldsFinal) {
          totalFields = 44;
        }
        // console.log(totalFields, "Total Fields2s");
        if (profileImg != null && profileImg != undefined && profileImg != '') {
          filledFields++;
        }
        let percentageFilled = 0;
        percentageFilled = (filledFields / totalFields) * 100;
        if (percentageFilled.toFixed() > 100) {
          state.profileCompletionRedux = 100;
        } else {
          state.profileCompletionRedux = percentageFilled.toFixed();
        }
      } catch (error) {
        // console.log("Redux Profile Error", error);
      }
    },
    getTopbarProfileReducer: (state, action) => {
      if (action.payload > 100) {
        state.profileProgress = 100;
      } else {
        state.profileProgress = action.payload;
      }
    },
    resetState: (state, action) => {
      state.formStepName = {};
      state.profileProgress = 0;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  profileProgressValue,
  getTopbarProfileReducer,
  resetState,
  setTotalFields,
  setProfile,
  resetProgressStates,
} = profileSlice.actions;

export default profileSlice.reducer;
